import { ca } from '@cian/analytics';
import { ITrackingExtra } from '../Notification';

export function trackingNotificationIconClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Notification',
    action: 'Click',
    label: 'icon',
  });
}

export function trackingNotificationClick(withPush: boolean, extra: ITrackingExtra) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Notification',
    action: 'Click',
    label: withPush ? 'read_push' : 'read_not_push',
    page: {
      extra,
    },
  });
}

export function trackingDeleteAllClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Notification',
    action: 'Click',
    label: 'delete_all',
  });
}

export function trackingMarkAllAsRead() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Notification',
    action: 'Click',
    label: 'read_all',
  });
}

export function trackingSettingsIconClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Notification',
    action: 'Click',
    label: 'settings',
  });
}
